import { URL } from '../constants';
import { apiInstance } from '../instance';

export const getUnreadCount = () => apiInstance.get(URL.UNREAD_ON_WAY_BOARD);
